/**
 * Router which renders views related to `Group` models.
 * @module app/routers/admin/Groups
 */
import RouterBase from "app/routers/RouterBase";
import CollectionTableView from "core/views/CollectionTableView";
import Field from "core/models/Field";
import GroupCollection from "app/models/GroupCollection";
import Group from "app/models/Group";
import DetailView from "app/views/admin/groups/Details";
import FormView from "app/views/admin/groups/Edit";
import ModelOperations from "core/operations/ModelOperations";
import NavigationOperations from "core/operations/NavigationOperations";
import RequestUtils from "app/utils/RequestUtils";
import app from "app/App";
export default RouterBase.extend({
  root: "/admin/groups",
  initialize: function (options) {
    RouterBase.prototype.initialize.apply(this, arguments);
  },

  load: function () {
    this.collection = new GroupCollection([]);

    return RequestUtils.fetchToPromise(this.collection);
  },

  routerSettings: {
    title: "Groups",
  },

  routes: {
    "admin/groups": "list",
    "admin/groups/Details/:id": "details",
    "admin/groups/Create": "create",
    "admin/groups/Edit/:id": "edit",
  },

  /**
   * Renders a list of groups.
   */
  list: function () {
    var view = new CollectionTableView({
      fields: [
        new Field(Group.fields["name"]).decorate({
          viewOptions: {
            type: "link",
            linkUrl: this.root.substring(1) + "/Details",
            linkField: "name",
          },
          id: "id",
          name: "id",
          label: "Group",
          filterable: "name",
        }),
      ],
      collection: this.collection,
      allowSave: false,
      allowDelete: false,
      mode: "view",
      className: CollectionTableView.prototype.className + " admin-group-list",
    });

    view.render();

    app.registerItemAction(
      NavigationOperations.createNavigationOperation("Create", "plus", "Create")
    );

    app.pushView(view);
  },

  /**
   * Renders a view which shows group details.
   * @param  {string} id The ID of the group to display.
   */
  details: function (id) {
    var view = new DetailView({
      model: this.collection.get(id),
    });

    view.render();

    app.registerNavigationAction("back");
    app.registerItemAction(
      NavigationOperations.createNavigationOperation(
        "Edit",
        "pencil",
        "Edit/" + id
      )
    );

    app.pushView(view);
  },

  /**
   * Renders a view which can be used to create a group.
   */
  create: function () {
    var model = new Group();

    model.collection = this.collection;
    var view = new FormView({
      model: model,
    });

    view.render();

    app.registerNavigationAction("back");
    app.registerItemAction(
      ModelOperations.create("Group", view, this.collection, true),
      model
    );

    app.pushView(view);
  },

  /**
   * Renders a view which can be used to modify a group.
   * @param  {string} id The ID of the group to modify.
   */
  edit: function (id) {
    var model = this.collection.get(id);
    var view = new FormView({
      model: model,
    });

    view.render();

    app.registerNavigationAction("back");
    app.registerItemAction(
      ModelOperations.destroy("Group", this.collection),
      model
    );
    app.registerItemAction(ModelOperations.save("Group", view, true), model);

    app.pushView(view);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/admin/Groups.js
// module id = 929
// module chunks = 1